import React from "react";
import WidgetsCards from "@techsoftware/happay-widgets/Card";

const Cards = props => {
    return <WidgetsCards {...props} />;
};

export default Cards;
